<template>
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      :value="checkbox.term_id"
      :id="checkbox.taxonomy + '_' + checkbox.term_id"
      v-model="value"
    />
    <label
      class="form-check-label"
      :for="checkbox.taxonomy + '_' + checkbox.term_id"
      v-html="checkbox.name"
    ></label>
  </div>
</template>

<script>
export default {
  name: "CheckboxToggle",
  props: ["checkbox", "tax_key"],
  computed: {
    value: {
      get() {
        if (
          this.$store.state.taxonomies[this.tax_key].active.indexOf(
            this.checkbox.term_id
          ) > -1
        ) {
          return true;
        }

        return false;
      },
      set(val) {
        const mutation = val ? "ADD_TAXONOMY" : "REMOVE_TAXONOMY";
        this.$store.commit(mutation, [this.tax_key, this.checkbox.term_id]);
        this.$store.dispatch("newRequest");
      },
    },
  },
};
</script>
